// import {FC, useEffect, useState} from 'react'
// import {KTIcon} from '../../../_metronic/helpers'
// import {SizeUnits, dateFormat, encodeString, isNullOrEmpty} from '../../../services/Utils'
// import {BaseRequest} from '../../../services/Request'
// import {CDN_URL, FlipbookGetByID} from '../../../services/main'
// import {toast} from 'react-toastify'
// import 'react-confirm-alert/src/react-confirm-alert.css'
// import {useTranslation} from 'react-i18next'
// import {Link, useParams} from 'react-router-dom'
// import clsx from 'clsx'
// import {PageLink, PageTitle} from '../../../_metronic/layout/core'
// import MonthlyStat from './stats/time'
// import LocationStat from './stats/location'
// import ScanedDevices from './stats/device'
// import ScanedOs from './stats/os'

import {Link, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useTranslation} from 'react-i18next'
import {FC, useEffect, useState} from 'react'
import {BaseRequest, CustomerChangePassReq} from '../../../services/Request'
import {toast} from 'react-toastify'
import {KTIcon} from '../../../_metronic/helpers'
import {
  CDN_URL,
  CustomerChangePass,
  CustomerGet,
  OrderGet,
  ProductSambarGet,
  ProductTatlagaGet,
} from '../../../services/main'
import clsx from 'clsx'
import {isNullOrEmpty, moneyFormat} from '../../../services/Utils'
import DataTable from '../../modules/CustomBootsrapTable/CustomBootsrapTable'
import {profile} from 'console'
import {OrderLists} from '../order/orderlist'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: 'Нүүр',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Самбар',
    path: '/product-sambar',
    isSeparator: false,
    isActive: false,
  },
]

const CustomerMore: FC = () => {
  const {id} = useParams<any>()
  const {t} = useTranslation()
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState<any>([])
  const [products, setProducts] = useState<any>([])
  const [tab, setTab] = useState('order')
  const [PID, setPID] = useState(1)
  const [PTotal, setPTotal] = useState(1)
  const [sizePerPage, setSizePerPage] = useState(10)
  const [oldpass, setOldpass] = useState('')
  const [newpass, setNewpass] = useState('')

  useEffect(() => {
    get()
  }, [])

  const change = () => {
    if (!loading) {
      setLoading(true)
    }
    var req = CustomerChangePassReq
    req.CustomerID = id as string
    req.newPassword = newpass
    req.OLdPass = oldpass
    req.IsAdmin = true
    CustomerChangePass(req, onChangeSuccess, onFailed, 'POST')
  }

  const onChangeSuccess = (response: any) => {
    setLoading(false)
    return toast.success(t('common:SuccessEdit'))
  }

  const get = () => {
    setLoading(true)
    CustomerGet(id, BaseRequest, onGetSuccess, onFailed, 'GET')
  }

  const onGetSuccess = (response: any) => {
    setLoading(false)
    setData(response.data)
    // setPageTitle(this.state.item.name);
  }

  const onFailed = (error: string) => {
    setLoading(false)
    return toast.error(error)
  }
  //   var newName = null
  //   if (!isNullOrEmpty(data.image_link)) {
  //     newName = data.image_link.split('.')
  //   }
  const defaultRowFormat = (cell: any, row: any) => {
    return <span className='flex justify-center'>{cell}</span>
  }
  const songolt1RowFormat = (cell: any, row: any) => {
    return row.product_type == 'tatlaga' ? (
      <span style={{fontSize: 11}}>{t(`common:magicnum.ProductTatlagaJin.${cell}`)}</span>
    ) : (
      <span style={{fontSize: 11}}>{t(`common:magicnum.ProductSambarHemjee.${cell}`)}</span>
    )
  }
  const songolt2RowFormat = (cell: any, row: any) => {
    return row.product_type == 'tatlaga' ? (
      <span style={{fontSize: 11}}>{t(`common:magicnum.ProductTatlagaUrt.${cell}`)}</span>
    ) : (
      <span style={{fontSize: 11}}>{t(`common:magicnum.ProductSambarMaterial.${cell}`)}</span>
    )
  }
  const imgRowFormat = (cell: any, row: any) => {
    var newName = row.product_type == 'tatlaga' ? row.timage.split('.') : row.simage.split('.')
    return (
      <div className='text-center'>
        <img
          src={CDN_URL + newName[1] + '-thumb.' + newName[2]}
          height={40}
          width={40}
          style={{borderRadius: '50%', objectFit: 'cover'}}
        />
      </div>
    )
  }
  const priceRowFormat = (cell: any, row: any) => {
    return <span className='flex justify-center'>{moneyFormat(cell, 'MNT')}</span>
  }
  const totalpriceRowFormat = (cell: any, row: any) => {
    return <span className='flex justify-center'>{moneyFormat(cell * row.price, 'MNT')}</span>
  }

  const onChangePage = (pid: any) => {
    if (pid >= 1) {
      setPID(pid)
      setLoading(true)
    }
  }
  var table = {
    sizePerPage: sizePerPage,
    headerKeyColumn: {
      title: 'id',
      dataField: 'PrivNo',
      dataSort: true,
      dataFormat: defaultRowFormat,
      hidden: true,
      filter: {
        type: 'TextFilter',
        placeholder: '...',
      },
    },
    headerOtherColumn: [
      {
        title: 'Барааны зураг',
        dataField: 'simage',
        dataSort: false,
        dataFormat: imgRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Бараа',
        dataField: 'sname',
        dataSort: false,
        dataFormat: defaultRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Код',
        dataField: 'scode',
        dataSort: false,
        dataFormat: defaultRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Даац, хэмжээ',
        dataField: 'songolt1',
        dataSort: false,
        dataFormat: songolt1RowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Урт, материал',
        dataField: 'songolt2',
        dataSort: false,
        dataFormat: songolt2RowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Барааны төрөл',
        dataField: 'product_type',
        dataSort: false,
        dataFormat: defaultRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Нэгж үнэ',
        dataField: 'price',
        dataSort: false,
        dataFormat: priceRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Захиалсан тоо',
        dataField: 'too',
        dataSort: false,
        dataFormat: defaultRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
      {
        title: 'Нийт үнэ',
        dataField: 'too',
        dataSort: false,
        dataFormat: totalpriceRowFormat,
        hidden: false,
        filter: {
          type: 'TextFilter',
          placeholder: '...',
        },
      },
    ],
  }

  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>{data?.name}</PageTitle>
      <div className={`card mb-5`}>
        <div style={{overflowX: 'auto'}} className='card-header border-1 w-full'>
          <div className='flex gap-8 col-form-label w-full card-header-flex'>
            <div className='flex flex-wrap gap-16 p-8 infos w-full'>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '14px',
                  justifyContent: 'center',
                }}
              >
                <div>
                  <span style={{fontWeight: 'bold'}}>Харилцагчийн нэр:</span>
                  <span> {data?.name}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>Харилцагчийн РД:</span>
                  <span> {data?.rd}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>И-мейл:</span>
                  <span> {data?.email}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>Гар утасны дугаар:</span>
                  <span> {data?.mobile}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>Ажлын утасны дугаар:</span>
                  <span> {data?.telephone}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>Холбогдох хүн:</span>
                  <span> {data?.holbogdoh_hun}</span>
                </div>
                <div>
                  <span style={{fontWeight: 'bold'}}>Албан тушаал:</span>
                  <span>{data?.alban_tushaal}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='card'>
        <div style={{overflowX: 'auto'}} className='card-header card-header-stretch'>
          <ul
            className=' nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
            role='tablist'
          >
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {
                  active: tab === 'order',
                })}
                onClick={() => setTab('order')}
                role='tab'
              >
                Захиалгууд
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={clsx(`nav-link cursor-pointer`, {
                  active: tab === 'changepass',
                })}
                onClick={() => setTab('changepass')}
                role='tab'
              >
                Нууц үг солих
              </a>
            </li>
          </ul>
        </div>
        <form className='form'>
          <div className='card-body py-6'>
            {tab === 'order' ? (
              <div className='card-body py-3'>
                <OrderLists customerId={id} type="component"/>
              </div>
            ) : null}
            {tab === 'changepass' ? (
              <div className='card-body py-3'>
                <div className='flex flex-col gap-4'>
                  <div className='flex flex-col '>
                    <span>Хуучин нууц үг</span>
                    <input
                      className='form-control form-control-solid w-300px'
                      type='text'
                      onChange={(e) => setOldpass(e.target.value)}
                      value={oldpass}
                    />
                  </div>
                  <div className='flex flex-col '>
                    <span>Шинэ нууц үг</span>
                    <input
                      className='form-control form-control-solid w-300px'
                      type='text'
                      onChange={(e) => setNewpass(e.target.value)}
                      value={newpass}
                    />
                  </div>
                  <button onClick={change} className='btn btn-primary w-300px'>
                    Хадгалах
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </form>
      </div>
    </>
  )
}

export {CustomerMore}
